module.exports = __webpack_public_path__ + "static/media/event-3.3af81d67.jpg";